import React from 'react';
import { Chip } from '@mui/material';

// forwardRef so callers can wrap this in a MUI <Tooltip> (ADR-014 §10i) — the
// tooltip needs to attach a ref to the underlying element.
const FilterChip = React.forwardRef(({
  label,
  isSelected,
  onClick,
  backgroundColor,
  textColor,
  borderColor,
  showDot = false,
  dotColor,
  sx = {},
  ...chipProps
}, ref) => {
  return (
    <Chip
      ref={ref}
      label={label}
      onClick={onClick}
      sx={{
        backgroundColor: isSelected ? backgroundColor : 'transparent',
        color: textColor,
        border: '1px solid',
        borderColor: borderColor,
        '&:hover': {
          backgroundColor: isSelected ? backgroundColor : 'rgba(0, 0, 0, 0.04)',
        },
        height: '32px',
        '& .MuiChip-label': {
          fontSize: '14px',
          padding: '0 16px',
          fontWeight: 500,
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          '&::before': (isSelected && showDot) ? {
            content: '""',
            display: 'inline-block',
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: dotColor || textColor
          } : {}
        },
        ...sx
      }}
      {...chipProps}
    />
  );
});

FilterChip.displayName = 'FilterChip';

export default FilterChip;
